<!-- v-htmlを用いる必要のあるデータの表示に使う -->
<template>
  <p v-html="text" :data-test="dataTest" />
</template>

<script>
import VueTypes from "vue-types";

export default {
  props: {
    text: VueTypes.string.isRequired,
    dataTest: VueTypes.string
  }
};
</script>
